// Module
var code = `<template> <div class="partial-require-intervention row col-12"> <text-box class="col-gutter col-12 col-sm-6 col-md-3 margin-bottom align-self-center" label="Status Snippet" value.two-way="meta.statusSnippet" readonly.to-view="isReadOnly"></text-box> </div> </template> `;
// Exports
module.exports = code;